// extracted by mini-css-extract-plugin
export default {"container":"Row_container__eVWSS","label":"Row_label__fjjRQ","value":"Row_value__Va3RW","unit":"Row_unit__JB2ed"};